import React from 'react';

import { LIVE_PATH_COLOR, PLANNED_PATH_COLOR } from './map-style';

const LegendRow = ({ color, label }: { color: string; label: string }) => (
  <div className="flex items-center gap-2">
    <span
      aria-hidden
      className="h-1 w-5 shrink-0 rounded-full"
      style={{ backgroundColor: color }}
    />
    <span className="text-xs font-semibold text-ro-black">{label}</span>
  </div>
);

/**
 * Static map key adapted from RushOS's trip-map legend: always visible,
 * both entries shown even before trip data or live tracking arrives. On
 * mobile it sits in the top-left corner, baseline-aligned with the LIVE
 * pill opposite it; at lg+ it moves to the map area's bottom-left, clear
 * of the sidebar and the bottom-right zoom controls.
 */
const MapLegend = () => (
  <div className="absolute left-4 top-4 z-20 space-y-1.5 rounded-xl bg-white/95 px-3 py-2.5 shadow-card lg:bottom-[22px] lg:left-[436px] lg:top-auto">
    <LegendRow color={LIVE_PATH_COLOR} label="Live route" />
    <LegendRow color={PLANNED_PATH_COLOR} label="Planned route" />
  </div>
);

export default MapLegend;
